import { CatalogResourceType } from "@evergis/api";
import { textOverflowEllipsisMixin, Icon, Popup, Divider, DialogActions, Dialog, ActionsGroup } from "@evergis/ui";

import styled, { css, keyframes } from "styled-components";
// eslint-disable-next-line max-len
import { getFileTypeIcon } from "../../../modules/FeatureCard/components/Attributes/components/Attachments/getFileTypeIcon";
import { FileType } from "../../../modules/FeatureCard/components/Attributes/components/Attachments/types";

import folderPreview from "./assets/folder_preview.svg";
import { getResourceColor } from "./ResourceItem/getResourceColor";

export const StyledDialog = styled(Dialog)`
  border-radius: 12px;
  position: relative;
`;

export const ActionsHeader = styled(ActionsGroup)`
  flex-direction: row !important;
  flex-wrap: nowrap !important;
  flex-grow: 0;
`;

export const FileTreeContainer = styled.div`
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.palette.background};
  min-height: 414px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  position: relative;
  flex-grow: 1;
`;

export const CircularProgressContainer = styled.div`
  margin: auto auto auto calc(50% - 2rem);
`;

export const ActionsContainer = styled.div``;

export const FileTreeWrapper = styled.div<{ previewActive?: boolean }>`
  overflow-y: scroll;
  width: ${({ previewActive }) => (previewActive ? "calc(100% - 18rem)" : "100%")};
  box-sizing: border-box;
  padding-left: 3rem;
  padding-right: ${({ previewActive }) => (previewActive ? "0" : "3rem")};
`;

export const HeaderTitle = styled.div`
  font-size: 1.5rem;
  margin-left: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0 1rem;
`;

export const EditResourceContainer = styled.div`
  width: 290px;
  flex-shrink: 0;
  box-sizing: border-box;
  padding: 0 0.75rem 1.5rem 1.5rem;
  background: ${({ theme }) => theme.palette.background};
  right: 0;
  position: sticky;
  overflow-y: scroll;
`;

export const ResourcePreviewContainer = styled.div`
  width: 15rem;
  height: 11.25rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PreviewIconResourceContainer = styled.div<{
  fileType?: FileType;
  type?: CatalogResourceType;
  isFolder?: boolean;
}>`
  width: 15rem;
  height: 11.25rem;
  flex-shrink: 0;
  position: relative;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  background-color: ${({ fileType, type, theme, isFolder }) =>
    isFolder ? "rgba(0, 170, 255, 0.06)" : getResourceColor(fileType, type) || theme.palette.elementDark};
`;

export const PreviewIconResource = styled.img<{ fileType?: FileType }>`
  border-radius: 1rem;
  object-fit: cover;
  flex-shrink: 0;
  position: absolute;
  right: 0;

  width: 11.25rem;
  height: 11.25rem;
  top: 0;

  ${({ fileType }) =>
    fileType === FileType.PostgresSchema
      ? css`
          width: 7.5rem;
          height: 7.5rem;
          top: 1.875rem;
          border-radius: 0;
        `
      : ""}
`;

export const PreviewIconFolderContainer = styled.div<{ isFolder?: boolean }>`
  width: 10rem;
  height: 7.5rem;
  flex-shrink: 0;
  position: relative;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme, isFolder }) => (isFolder ? "rgba(0, 170, 255, 0.06)" : theme.palette.elementDark)};
`;

export const PreviewIconFile = styled.div<{ isDirectory: boolean; fileType?: FileType }>`
  width: 3rem;
  height: 3rem;
  margin: auto;

  background: url(${({ isDirectory, fileType }) => (isDirectory ? folderPreview : getFileTypeIcon(fileType))}) center
    center no-repeat;
`;

export const ResourceTitle = styled.div`
  font-size: 14px;
  margin-top: 1rem;
`;

export const ResourcePath = styled.div`
  font-size: 12px;
  opacity: 0.36;
  margin-top: 2px;
  text-align: left;
  direction: rtl;
  text-overflow: ellipsis;
  overflow: hidden;
  unicode-bidi: normal;
`;

export const ResourceDescription = styled.div`
  font-size: 12px;
  margin-top: 0.5rem;
  max-width: 7rem;
  word-wrap: break-word;
`;

export const ResourceField = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  margin-top: 0.5rem;
  align-items: baseline;
`;

export const StyledMenuPopup = styled(Popup)`
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
`;

export const ActionsState = styled.div<{ error?: boolean }>`
  display: flex;
  align-items: center;
  margin-right: 1.5rem;
  color: ${({ theme, error }) => (error ? theme.palette.error : theme.palette.primary)};
  font-size: 14px;
  cursor: pointer;
  gap: 0 0.75rem;

  ${Icon} {
    &:after {
      color: ${({ theme, error }) => (error ? theme.palette.error : theme.palette.primary)};
    }
  }
`;

export const ActionsStateText = styled.div`
  font-size: 14px;
  ${textOverflowEllipsisMixin}
`;

export const StyledDialogActions = styled(DialogActions)`
  align-items: center;
  flex-shrink: 0;
  margin-top: auto;
  padding-bottom: 1.5rem;
  padding-top: 1.5rem;
  padding-left: 3rem;
`;

export const StyledActionsButtonsGroup = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 0 1rem;
`;

export const StyledIconsGroup = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const SelectedText = styled.div`
  color: ${({ theme }) => theme.palette.icon};
  font-size: 14px;
`;

export const StyledDivider = styled(Divider)`
  height: 1rem;
`;

export const IconLabel = styled.label`
  color: ${({ theme }) => theme.palette.primary};
  font-size: 14px;
  cursor: pointer;
`;

export const SearchHeader = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  gap: 0 0.5rem;
`;

export const fadeInKeyframes = keyframes`
    0% {
    opacity: 0;
  } 100% {
    opacity: 1;
  }
`;

export const FiltersOverlay = styled.div`
  position: absolute;
  z-index: 1;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.25);
  animation: ${fadeInKeyframes} 0.3s ease-in-out;
`;

export const ResourcesRefreshContainer = styled.div``;

export const ResourcesHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 2rem 3rem 0.5rem;
  width: 100%;
  box-sizing: border-box;

  ${ResourcesRefreshContainer} {
    visibility: hidden;
  }

  &:hover {
    ${ResourcesRefreshContainer} {
      visibility: visible;
    }
  }
`;
